import { Component } from '@angular/core';

@Component({
    selector: 'ct-server-error',
    templateUrl: 'server-error.component.html',
    standalone: false
})

export class ServerErrorComponent {
}
